import { devtools } from 'config/devtools'
import { create } from 'zustand'

import { UseSelectedTransitionTable } from './types'

export const useSelectedTransitionTable = create<UseSelectedTransitionTable>()(
  devtools(
    (set) => ({
      selectedIds: [],
      setSelectedIds: (state) => {
        set((prev) => {
          const selectedIds = typeof state === 'function' ? state(prev.selectedIds) : state
          return { selectedIds }
        })
      },
      clear: () => set({ selectedIds: [] }),
    }),
    {
      store: 'selectedTransitionTable',
    },
  ),
)
